import { useQuery } from '@apollo/client';
import {
    GET_COMMON_CONFIG_BY_KEY,
    GetCommonConfigByKeyResponse,
    GetCommonConfigByKeyVariables,
} from '../../../config/common-config/graphql/commonConfigQueries';

/**
 * 包牌查询降级开关 configKey：bag.query.degrade.enable。
 * true → 走降级路径（PDA 只查运单；desktop 包牌详情时间轴只保留 CURRENT 节点）。
 * "获取不到默认 true" — loading / error / config 不存在 / isActive=false / configValue !== 'false' 一律 true。
 * 仅在 configValue.toLowerCase() === 'false' 且 isActive 才返回 false（正常路径）。
 */
export const BAG_QUERY_DEGRADE_CONFIG_KEY = 'bag.query.degrade.enable';

export function useBagQueryDegradeEnabled(): boolean {
    const { data, loading, error } = useQuery<GetCommonConfigByKeyResponse, GetCommonConfigByKeyVariables>(
        GET_COMMON_CONFIG_BY_KEY,
        { variables: { configKey: BAG_QUERY_DEGRADE_CONFIG_KEY }, fetchPolicy: 'cache-and-network' }
    );
    if (loading || error) return true;
    const config = data?.getCommonConfigByKey;
    if (!config || !config.isActive) return true;
    return (config.configValue || '').trim().toLowerCase() !== 'false';
}
